/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import styled from 'styled-components';

export const OrderIdFileStyled = styled.div.attrs({
    className: 'order-file',
})`
    display: grid;
    grid-template-columns: 32px auto;
    grid-gap: 8px;
    align-items: center;

    .order-file__icon {
        height: 32px;
    }

    .order-file__extension {
        grid-column: 2 / 3;
    }
`;
